@if (isInitialized) {
  <oe-flat-widget [title]="component.alias" [icon]="{ name: 'oe-heating-element', color: 'normal' }" button link="/device/{{ edge.id }}/history/{{ componentId }}/heatingelementchart">
    @for (i of [1, 2, 3]; track i) {
      <oe-flat-widget-line [name]="'EDGE.HISTORY.ACTIVE_DURATION_WITH_LEVEL' | translate: { level: i }" [channelAddress]="component.id + '/Level' + i + 'CumulatedTime'" [converter]="FORMAT_SECONDS_TO_DURATION"></oe-flat-widget-line>
    }
    @if (consumptionMeter && consumptionMeter.isEnabled) {
      <oe-flat-widget-line [name]="'GENERAL.CONSUMPTION' | translate" [channelAddress]="consumptionMeter.id + '/ActiveProductionEnergy'" [converter]="Utils.CONVERT_TO_KILO_WATTHOURS"></oe-flat-widget-line>
    }
  </oe-flat-widget>
}
